@if (adminDtos) {
  <div class="page-root">
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ "admin.admin_type.label" | transloco }}</mat-card-title>
      </mat-card-header>

      <mat-card-content class="column-stretch">
        <mat-form-field>
          <mat-label>{{ "admin.admin_type.label" | transloco }}</mat-label>
          <mat-select [formControl]="adminTypeSelector" (valueChange)="changeAdminType($event)">
            @for (adminType of adminTypes; track $index) {
              <mat-option [value]="adminType">{{ adminType | adminType }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-header class="row-space-between">
        <mat-card-title>{{ adminTypeSelector.value | adminTypeTitle }}</mat-card-title>

        <div class="card-action" (click)="addAdmin()">
          <mat-icon> add_circle</mat-icon>
          <mat-label>{{ "admin.add_admin" | transloco }}</mat-label>
        </div>
      </mat-card-header>

      <mat-card-content>
        <mat-table [dataSource]="adminDtos" class="width-none" #table>
          <ng-container matColumnDef="firstname">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.first_name" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let admin">{{ admin.firstName }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="lastname">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.last_name" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let admin">{{ admin.lastName }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.email" | transloco}}</mat-header-cell>
            <mat-cell *matCellDef="let admin">{{ admin.email }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="link">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.direct_url" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let admin">
              @if (locationSummaryDtos.length == 1) {
                <button mat-icon-button (click)="copyUrl(locationSummaryDtos[0].locationId)">
                  <mat-icon>link</mat-icon>
                </button>
              }
              @if (locationSummaryDtos.length > 1) {
                <button mat-icon-button [matMenuTriggerFor]="locationMenu">
                  <mat-icon>link</mat-icon>
                </button>
                <mat-menu #locationMenu="matMenu">
                  @for (location of locationSummaryDtos; track $index) {
                    <button mat-menu-item (click)="copyUrl(location.locationId)">{{ locationName(location.locationId) }}</button>
                  }
                </mat-menu>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let admin" class="row-end">
              @if (!loggedInAdminEmail || loggedInAdminEmail !== admin.email) {
                <button mat-icon-button (click)="editAdmin(admin)">
                  <mat-icon>edit</mat-icon>
                </button>
              }
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef='["firstname", "lastname", "email", "link", "edit"]'></mat-header-row>
          <mat-row *matRowDef='let admin columns: ["firstname", "lastname", "email", "link", "edit"]'></mat-row>
        </mat-table>
      </mat-card-content>
    </mat-card>
  </div>
}
